module.exports = __webpack_public_path__ + "static/media/check-icon-green.c497876a.svg";